import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate,useLocation } from "react-router-dom";
import "../styles/Profile.css"; // Import the CSS file for styling
import Header from "../components/Header";
import Footer from "../components/Footer";

function Profile() {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [currentTime, setCurrentTime] = useState("");
  const [logData, setLogData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(4);

  useEffect(() => {
    axios
      .get("https://utsb.utahdata.org/bdxbackend/auth/me", {
        withCredentials: true,
      })
      .then(({ data }) => {
        if (data.authenticated) {
          console.log(data.user);
          localStorage.setItem("user", data.user.name);
          setUser(data.user);
        } 
        else {
          setUser(null);
          navigate("/login", { replace: true }); // 🔑 redirect to /login
        }
      })
      .catch(() => {
        setUser(null);
        navigate("/login", { replace: true }); // 🔑 redirect if request fails
      });
  }, [navigate]);

  useEffect(() => {
    //  const [user, setUser] = useState(null);
    // const name = location.state?.name || "user"; // fallback if no name

    //  const savedUser = localStorage.getItem('user');
    // if (savedUser) {
    //   setUser(JSON.parse(savedUser)); // Parse and set the user data
    // }
    const loginActivity = async () => {
      try {
        const token = localStorage.getItem("token");
        if (token) {
          const response = await axios.get(
            "https://utsb.utahdata.org/bdxbackend/api/utahdata/login-activity",
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setLogData(response.data);
          console.log(response.data);
        } else {
          console.log("No token found in localStorage");
        }
      } catch (error) {
        console.error("Error fetching login activity:", error);
      }
    };

    loginActivity();

    const getCurrentTimeInMDT = () => {
      const options = {
        timeZone: "America/Denver",
        hour12: true,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      };
      const currentTime = new Intl.DateTimeFormat("en-US", options).format(
        new Date()
      );
      setCurrentTime(currentTime);
    };

    const interval = setInterval(getCurrentTimeInMDT, 1000);
    getCurrentTimeInMDT();

    return () => clearInterval(interval);
  }, []);

  // Function to format the attempt time
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
  };

  // profile-pagination Logic
  const indexOfLastActivity = currentPage * itemsPerPage;
  const indexOfFirstActivity = indexOfLastActivity - itemsPerPage;
  const currentActivities = logData.activity?.slice(
    indexOfFirstActivity,
    indexOfLastActivity
  );

  const totalPages = Math.ceil(logData.total / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div>
      <Header />
      <div className="profile-container flex flex-col bg-gray-100">
        <div className="mdt-time">
          <h2 className="text-black">Time (MDT): {currentTime}</h2>
        </div>
        <div className="profile-card mt-[2rem]">
          <h1 className="profile-title"> Profile</h1>
          <div className="profile-info">
            <span className="profile-label">Name:</span>
            <span className="profile-value">
              {user?.name || "Not available"}
            </span>
          </div>
          <div className="profile-info">
            <span className="profile-label">Email:</span>
            <span className="profile-value">
              {user?.email || "Not available"}
            </span>
          </div>
          <div className="profile-info">
            <span className="profile-label">Account type:</span>
            <span className="profile-value">
              {user?.account_type || "Not available"}
            </span>
          </div>
        </div>

        {/* Display the current MDT time */}

        {/* <div className="login-activity-container">
        <h1>User Login Activity</h1>

       
        {logData.activity && logData.activity.length > 0 ? (
  <div>
    <h3>Total Activities: {logData.total}</h3>

   
    <div className="login-activity-list flex flex-row flex-wrap gap-1 sm:gap-6 justify-center">
      {currentActivities?.map((activity, index) => (
        <div className="login-activity-card w-full sm:w-1/2 md:w-1/3 lg:w-1/4" key={index}>
          <p className="activity-time"><strong>Attempt at:</strong> {formatDate(activity.attempt_at)}</p>
          <p className="activity-ip"><strong>IP Address:</strong> {activity.ip_address}</p>
          <p className="activity-status">
            <strong>Status: </strong>
            {activity.was_successful ? (
              <span className="success-status">Successful</span>
            ) : (
              <span className="failure-status">Failed</span>
            )}
          </p>
          {activity.failure_reason && <p className="failure-reason"><strong>Failure Reason:</strong> {activity.failure_reason}</p>}
        </div>
      ))}
    </div>

  }
    <div className="profile-pagination">
      <button
        onClick={() => paginate(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Previous
      </button>
      <span>Page {currentPage} of {totalPages}</span>
      <button
        onClick={() => paginate(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        Next
      </button>
    </div>
  </div>
) : (
  <p>No login activities found.</p>
)}

      </div>
       </div> */}
        <div className="login-activity-container">
          <h1> Login Activity</h1>

          {/* Check if logData contains activity and render it */}
          {logData.activity && logData.activity.length > 0 ? (
            <div className=" bg-white rounded-lg py-5 px-2 border-2">
              <h3>Total Activities: {logData.total}</h3>

              {/* Table Layout for login activities */}
              <div className="table-responsive">
              <table className="table-auto responsive-table w-full text-left mt-4">
                <thead>
                  <tr className="border-b">
                    <th className="py-2 px-4">Attempt at</th>
                    <th className="py-2 px-4">IP Address</th>
                    <th className="py-2 px-4">Status</th>
                    <th className="py-2 px-4">Failure Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {currentActivities?.map((activity, index) => (
                    <tr key={index} className="border-b">
                      <td className="py-2 px-4" data-label="Attempt at">
                        {formatDate(activity.attempt_at)}
                      </td>
                      <td className="py-2 px-4" data-label="IP Address">{activity.ip_address}</td>
                      <td className="py-2 px-4" data-label="Status">
                        {activity.was_successful ? (
                          <span className="text-green-500">Successful</span>
                        ) : (
                          <span className="text-red-500">Failed</span>
                        )}
                      </td>
                      <td className="py-2 px-4" data-label="Failure Reason">
                        {activity.failure_reason || "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>

              {/* profile-pagination Controls */}
              <div className="profile-pagination mt-4">
                <button
                  onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="px-4 py-2 bg-blue-500 text-white rounded disabled:bg-gray-300"
                >
                  Previous
                </button>
                <span className="mx-4">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="px-4 py-2 bg-blue-500 text-white rounded disabled:bg-gray-300"
                >
                  Next
                </button>
              </div>
            </div>
          ) : (
            <p>No login activities found.</p>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Profile;
